(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const announcementBarSwiper = [...document.querySelectorAll('[js-announcement-bar="swiper"]')];

  announcementBarSwiper.forEach((bar) => {
    const swiper = new Swiper(bar, {
      loop: true,
      autoplay: {
       delay: 3000,
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
